import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faHome,
  faMapMarkerAlt,
  faBell,
  faChartBar,
  faUser,
  faSearch,
  faCheck,
  faCheckSquare,
  faSquare,
  faArrowLeft,
  faFilter,
  faPhone,
  faEnvelope,
  faClipboard,
  faClipboardCheck,
  faChartArea,
  faChartLine,
  faQuestionCircle,
  faPaperPlane,
  faComment,
  faHeadset,
}
from '@fortawesome/free-solid-svg-icons';

library.add(
  faHome,
  faMapMarkerAlt,
  faBell,
  faChartBar,
  faUser,
  faSearch,
  faCheck,
  faCheckSquare,
  faSquare,
  faArrowLeft,
  faFilter,
  faPhone,
  faEnvelope,
  faClipboard,
  faClipboardCheck,
  faChartArea,
  faChartLine,
  faQuestionCircle,
  faPaperPlane,
  faComment,
  faHeadset,
);
